import { useCallback } from "react"
import Button from "modules/Core/sub-modules/ui-kit/components/Button"
import strappedConnected from "modules/Core/higher-order-components/strappedConnected"
import withShouldRender from "modules/Core/higher-order-components/withShouldRender"
import withFocusedBoothId from "modules/booths/higher-order-components/withFocusedBoothId"
import cells from "modules/cycles/state"
import { ACTIVITY_KIND } from "modules/cycles/consts"
import styles from "./styles.module.scss"

const AddCycleActivityButton = ({
    text = "Add task",
    panel,
    className,
    onClick,
    ...props
}) => (
    <Button
        className={className}
        onClick={onClick}
        panel={panel}
        text={text}
        {...props}
    >
        {text}
    </Button>
)

export default withFocusedBoothId(strappedConnected(
    withShouldRender(AddCycleActivityButton),
    {
        activeCycle: cells.fetchCurrentCycle.selectors.activeCycle,
    },
    {
        refetchActive: (boothId) => cells.fetchCurrentCycle.action({ boothId }),
        upsert: (input, callback) => cells.upsertActivity.action({ input, callback }),
    },
    ({
        activeCycle,
        cycleId,
        boothId,
        onSuccess,
        panel,
        refetchActive,
        upsert,
        text = "Add task",
    }) => {
        const resolvedCycleId = cycleId ?? activeCycle?.id
        const resolvedBoothId = boothId ?? activeCycle?.boothId
        const handleSuccess = useCallback(() => {
            onSuccess?.()
            if (!cycleId && resolvedBoothId) refetchActive(resolvedBoothId)
        }, [onSuccess, cycleId, resolvedBoothId, refetchActive])

        return {
            shouldRender: Boolean(resolvedCycleId),
            onClick: () => upsert({
                cycleId: resolvedCycleId,
                boothId: resolvedBoothId,
                kind: ACTIVITY_KIND.PLACEHOLDER,
            }, handleSuccess),
            panel,
            noChevron: panel,
            span: panel,
            maxWidth: panel,
            className: panel && styles.panelButton,
            text,
        }
    }
))
